import React from 'react';
import { Image } from '@sitecore-jss/sitecore-jss-react';

const BrandAssurance = ({ fields }) => {
  return (
    <li className="vds-brand-assurance__list-item">
      <Image
        field={fields.image}
        editable={fields.editable?.value}
        width={fields.width?.value}
        height={fields.height?.value}
        alt={fields.image?.value?.alt}
      />
    </li>
  );
};

export default BrandAssurance;
